"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IssuesToDoMetaModel = void 0;
const QueryFieldKey_1 = __importDefault(require("@opsbase/lib-data-queryfield/QueryFieldKey"));
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const MetaModel_1 = __importDefault(require("../MetaModel"));
exports.IssuesToDoMetaModel = new MetaModel_1.default({
    name: () => lib_i18n_1.default.t('issues'),
    queryName: 'issuesToDo',
    alwaysGetGqlFields: `id,
		title,
		flag, type, status,
		occurrenceDate,
		deadlineDate,
		startedDate,
		updatedDate,
		closedDate,
		comments,
		activity,
		place { id, title, timezone },
	    createdBy { id, title, hasProfileImage, profileImageUrl   },
	    startedBy { id, title, hasProfileImage, profileImageUrl   },
	    updatedBy { id, title, hasProfileImage, profileImageUrl   },
	    closedBy { id, title, hasProfileImage, profileImageUrl   },
	    assignedToSPTType,
	    assignedToStaff { id, title, hasProfileImage, profileImageUrl },
	    assignedToPosition { id, title },
	    assignedToTeam { id, title },
	    commentors { id, title, hasProfileImage, profileImageUrl },
	    asset { id, title },
	    op { id, title, startFrom, completeBy, actualStart, actualComplete, isScoreEnabled, isAdhoc }`,
    filterables: [
        QueryFieldKey_1.default.PLACE,
        QueryFieldKey_1.default.TEAM,
        QueryFieldKey_1.default.POSITION,
        QueryFieldKey_1.default.ISSUE_STATUS,
        QueryFieldKey_1.default.ISSUE_DUESTATUS,
        QueryFieldKey_1.default.ISSUE_FLAG,
        QueryFieldKey_1.default.ISSUE_TYPE,
        QueryFieldKey_1.default.ISSUE_OCCURRENCEDATE,
        QueryFieldKey_1.default.ISSUE_DEADLINEDATE,
        QueryFieldKey_1.default.ASSET,
    ],
    groupables: [],
    fields: [],
});
exports.default = exports.IssuesToDoMetaModel;
